let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hJeYf")).then(() => parcelRequire('aMAFT'));